import React from 'react'

const SelectOption = ({ item, index, multiselect, selectedValues, labelClass, isSelected, handleSelect, checkbox, optionClass, allOption }) => {
  
  const handleClick = (e) => {
    e.stopPropagation();
    handleSelect(item);
  };

  return (
    <li
      key={index}
      className={`w-full px-3 py-2 cursor-pointer hover:bg-slate-50 ${isSelected && allOption ? "bg-slate-100 hidden" : isSelected ? "bg-slate-100" : ''
        } ${optionClass}`}
      onClick={handleClick}
    >
      <div
        className={`flex items-center font-medium text-[17px] text-black cursor-pointer ${labelClass ? labelClass : " gap-3"}`}
      >
        {item.prefix || !multiselect ? (
          <div className="flex-shrink-0 flex items-center gap-2">
            {checkbox ? (
              <input
                type="checkbox"
                className="w-[17px] h-[17px] flex-shrink-0"
                id={item.id}
                value={item.value}
                checked={selectedValues?.some(
                  (selected) => selected.value === item.value
                )}
                onChange={handleClick}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <span className="w-0 h-0 overflow-hidden"></span>
            )}
            {item.prefix}
          </div>
        ) : (
          checkbox ? (
            <input
              type="checkbox"
              className="w-[17px] h-[17px] flex-shrink-0"
              id={item.id}
              value={item.value}
              checked={selectedValues?.some(
                (selected) => selected.value === item.value
              )}
              onChange={handleClick}
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <span className="w-0 h-0 overflow-hidden"></span>
          )
        )}
        <span className="truncate">{item.label}</span>
      </div>
    </li>
  )
}

export default SelectOption